const Partner = resolve => {
    require.ensure(['../views/apps/partner/Partner'], () => {
        resolve(require('../views/apps/partner/Partner'))
    })
};

const PartnerTanimla = resolve => {
    require.ensure(['../views/apps/partner/PartnerTanimla'], () => {
        resolve(require('../views/apps/partner/PartnerTanimla'))
    })
};
const PartnerListe = resolve => {
    require.ensure(['../views/apps/partner/PartnerListe'], () => {
        resolve(require('../views/apps/partner/PartnerListe'))
    })
};

const PartnerDuzenle = resolve => {
    require.ensure(['../views/apps/partner/PartnerDuzenle'], () => {
        resolve(require('../views/apps/partner/PartnerDuzenle'))
    })
};
const IlEkle = resolve => {
    require.ensure(['../views/apps/partner/IlEkle'], () => {
        resolve(require('../views/apps/partner/IlEkle'))
    })
};
import Vue from 'vue'

Vue.component('PartnerTanimla', PartnerTanimla);
Vue.component('PartnerListesi', PartnerListe);
Vue.component('PartnerDuzenle', PartnerDuzenle);
Vue.component('HaritaTanimla', IlEkle);

import layouts from '../layout'

export default {
    path: '/partner',
    name: 'partner',
    component: Partner,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'partnertanimla',
            component: PartnerTanimla,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'partnerliste',
            component: PartnerListe,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'guncelleme',
            name: 'partnerduzenle',
            component: PartnerDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'islem',
            name: 'kategoriislem',
            component: IlEkle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
